var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { applyBannerThumbnailSize, classNames } from '@shapeable/utils';
import { EntityValue } from './entity-value';
import { SliceLayout } from './slice-layout';
import { useLink } from '../hooks/use-link';
import { useComponentPropsFor } from '../context/component-props-context';
import { EntityTypeHeader } from './entity-type-header';
import { usePageEntity } from '../hooks/use-page-entity';
import { ThemeModeProvider } from '../context/theme-mode-context';
var cls = classNames('entity-banner');
export var EntityBannerDefaultProps = {
  variant: 'image',
  showSubheader: false,
  useBackgroundColor: true,
  useLinks: false,
  subHeaderBackgroundColor: 'brightWarm',
  showOverlay: false,
  showTitles: false,
  linkStyles: {
    textDecoration: 'none',
    cursor: 'pointer',
    display: 'flex',
    flexGrow: 1
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n    font-size: 1.1em;\n  "], ["\n    ", "\n    font-size: 1.1em;\n  "])), function (_a) {
    var colors = _a.colors,
      useLinks = _a.useLinks;
    return colors && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border-top: 3px solid ", ";\n    "], ["\n      border-top: 3px solid ", ";\n    "])), theme.COLOR(colors.border));
  }),
  tablet: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: 1.4em;\n  "], ["\n    font-size: 1.4em;\n  "]))),
  desktop: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: 1.5em;\n  "], ["\n    font-size: 1.5em;\n  "])))
});
var SliceStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    align-items: flex-end;\n    overflow: hidden;\n\n    ", "\n    \n    .shp--slice-layout__boundary {\n      padding-left: ", ";\n    }\n\n\n    ", "\n\n    ", "\n\n    ", "\n  "], ["\n    align-items: flex-end;\n    overflow: hidden;\n\n    ", "\n    \n    .shp--slice-layout__boundary {\n      padding-left: ", ";\n    }\n\n\n    ", "\n\n    ", "\n\n    ", "\n  "])), function (_a) {
    var maxHeight = _a.maxHeight;
    return maxHeight && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      max-height: ", "px;\n      .shp--slice-layout__boundary {\n        max-height: ", "px;\n      }\n    "], ["\n      max-height: ", "px;\n      .shp--slice-layout__boundary {\n        max-height: ", "px;\n      }\n    "])), maxHeight, maxHeight);
  }, theme.UNIT(2), function (_a) {
    var hasBackgroundImages = _a.hasBackgroundImages,
      useBackgroundColor = _a.useBackgroundColor,
      colors = _a.colors;
    return !hasBackgroundImages && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      background: ", ";\n    "], ["\n      background: ", ";\n    "])), useBackgroundColor ? "linear-gradient(180deg, rgba(0, 0, 0, 0.20) 20%, rgba(0, 0, 0, 0.00) 100%), ".concat(colors.background) : theme.COLOR('brightWarm'));
  }, function (_a) {
    var hasChildren = _a.hasChildren;
    return hasChildren && css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      .shp--slice-layout__boundary {\n        padding-top: ", ";\n      }\n    "], ["\n      .shp--slice-layout__boundary {\n        padding-top: ", ";\n      }\n    "])), theme.UNIT(2));
  }, function (_a) {
    var useLinks = _a.useLinks;
    return useLinks && css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      ", ";\n      cursor: pointer;\n      border-top: 3px solid transparent;\n    "], ["\n      ", ";\n      cursor: pointer;\n      border-top: 3px solid transparent;\n    "])), theme.TRANSITION('box-shadow'));
  }),
  desktopDevice: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var hasBottomCorners = _a.hasBottomCorners;
    return hasBottomCorners && css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      border-radius: 0 0 ", " ", ";\n    "], ["\n      border-radius: 0 0 ", " ", ";\n    "])), theme.UNIT(2), theme.UNIT(2));
  })
});
var LayoutStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    padding: ", " ", " ", ";\n\n    ", "\n\n    ", "\n  "], ["\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    padding: ", " ", " ", ";\n\n    ", "\n\n    ", "\n  "])), theme.UNIT(6), theme.UNIT(4), theme.UNIT(6), function (_a) {
    var slideControls = _a.slideControls;
    return slideControls && css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n      padding: ", " ", " ;\n    "], ["\n      padding: ", " ", " ;\n    "])), theme.UNIT(16), theme.UNIT(4));
  }, function (_a) {
    var useBackgroundColor = _a.useBackgroundColor;
    return css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), useBackgroundColor ? theme.COLOR('light') : theme.COLOR('text'));
  })
});
var TitlesStyles = breakpoints({
  base: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    width: 90%;\n  "], ["\n    width: 90%;\n  "])))
});
var TypeHeaderStyles = breakpoints({
  base: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    margin-bottom: ", ";\n    color: ", ";\n    ", ";\n    font-size: ", ";\n    font-weight: 200;\n    text-shadow: 0 0px 1px #00000033;\n  "], ["\n    margin-bottom: ", ";\n    color: ", ";\n    ", ";\n    font-size: ", ";\n    font-weight: 200;\n    text-shadow: 0 0px 1px #00000033;\n  "])), theme.UNIT(1), theme.COLOR('bright'), theme.TRANSITION('color'), theme.FONT_SIZE(12)),
  tablet: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme.FONT_SIZE(13)),
  desktop: css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme.FONT_SIZE(14))
});
var TitleStyles = breakpoints({
  base: css(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    margin: 0;\n    line-height: 1em;\n\n    ", "\n    font-weight: 400;\n    text-shadow: 0 0px 1px #00000033;\n  "], ["\n    margin: 0;\n    line-height: 1em;\n\n    ", "\n    font-weight: 400;\n    text-shadow: 0 0px 1px #00000033;\n  "])), function (_a) {
    var fontScale = _a.fontScale;
    return css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n      font-size: ", "em;\n    "], ["\n      font-size: ", "em;\n    "])), fontScale * 18 / 11);
  }),
  tablet: css(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    font-size: ", "em;\n    line-height: 1.1em;\n  "], ["\n    font-size: ", "em;\n    line-height: 1.1em;\n  "])), 18 / 11)
});
var SubHeaderContainerStyles = breakpoints({
  base: css(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n    padding: ", " ", " ", ";\n\n    ", "\n    \n  "], ["\n    padding: ", " ", " ", ";\n\n    ", "\n    \n  "])), theme.UNIT(4), theme.UNIT(4), theme.UNIT(6), function (_a) {
    var subHeaderBackgroundColor = _a.subHeaderBackgroundColor;
    return subHeaderBackgroundColor && css(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n      background: ", ";\n    "], ["\n      background: ", ";\n    "])), theme.COLOR(subHeaderBackgroundColor));
  }),
  desktopDevice: css(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n    border-radius: 0 0 ", " ", ";\n  "], ["\n    border-radius: 0 0 ", " ", ";\n  "])), theme.UNIT(2), theme.UNIT(2))
});
var OutlineEntityStyles = breakpoints({
  base: css(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n    ", "\n\n    .shp--entity-value__label-and-name h2.shp--entity-value__name {\n      font-size: ", ";\n    }\n\n  "], ["\n    ", "\n\n    .shp--entity-value__label-and-name h2.shp--entity-value__name {\n      font-size: ", ";\n    }\n\n  "])), function (_a) {
    var useBackgroundColor = _a.useBackgroundColor;
    return css(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), useBackgroundColor ? theme.COLOR('light') : theme.COLOR('strong'));
  }, theme.FONT_SIZE(22))
});
var ContentStyles = breakpoints({
  base: css(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n    font-weight: inherit;\n  "], ["\n    font-weight: inherit;\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme.UNIT(4))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Slice: styled(SliceLayout)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), SliceStyles),
  Layout: styled.div.attrs(cls.attr('layout'))(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  Titles: styled.div.attrs(cls.attr('titles'))(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), TitlesStyles),
  TypeHeader: styled(EntityTypeHeader).attrs(cls.attr('type-header'))(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), TypeHeaderStyles),
  Title: styled.span.attrs(cls.attr('title'))(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Content: styled.div.attrs(cls.attr('content'))(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_36 || (templateObject_36 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  SubHeaderContainer: styled.div.attrs(cls.attr('sub-header-container'))(templateObject_37 || (templateObject_37 = __makeTemplateObject(["", ""], ["", ""])), SubHeaderContainerStyles),
  OutlineEntity: styled(EntityValue)(templateObject_38 || (templateObject_38 = __makeTemplateObject(["", ""], ["", ""])), OutlineEntityStyles)
};
export var EntityBanner = function (props) {
  var _a, _b, _c;
  var _d = useComponentPropsFor('EntityBanner', EntityBannerDefaultProps, props),
    className = _d.className,
    variant = _d.variant,
    children = _d.children,
    customAspectRatio = _d.customAspectRatio,
    entityValueProps = _d.entityValueProps,
    showSubheader = _d.showSubheader,
    useBackgroundColor = _d.useBackgroundColor,
    useLinks = _d.useLinks,
    maxHeight = _d.maxHeight,
    subHeaderBackgroundColor = _d.subHeaderBackgroundColor,
    showOverlay = _d.showOverlay,
    showTitles = _d.showTitles,
    content = _d.content;
  var entity = props.entity;
  var Link = useLink().Link;
  var style = {
    textDecoration: 'none'
  };
  var defaultAspectRatios = {
    image: {
      base: 16 / 9,
      desktop: 21 / 9,
      desktopLarge: 3
    },
    overlay: {
      base: 4,
      desktop: 2
    },
    color: {
      base: 4,
      desktop: 3
    }
  };
  var backgroundImages = variant !== 'color' && (((_a = entity === null || entity === void 0 ? void 0 : entity.banners) === null || _a === void 0 ? void 0 : _a.length) ? entity === null || entity === void 0 ? void 0 : entity.banners : (entity === null || entity === void 0 ? void 0 : entity.banner) ? [entity === null || entity === void 0 ? void 0 : entity.banner] : (entity === null || entity === void 0 ? void 0 : entity.openGraph) ? [entity === null || entity === void 0 ? void 0 : entity.openGraph] : []).map(applyBannerThumbnailSize('mainBanner'));
  var currentEntity = usePageEntity();
  var hasBackgroundImages = backgroundImages.length > 0;
  var hasSubHeader = showSubheader && variant === 'image' && (!!entity.outlineNumber || !!entity.name);
  var hasBannerHeader = variant === 'overlay' || variant === 'color';
  var link = (entity === null || entity === void 0 ? void 0 : entity.url) || (entity === null || entity === void 0 ? void 0 : entity.path) || undefined;
  var isClickable = !!link && link !== currentEntity.path;
  var pageSlice = __assign(__assign({}, entity), {
    backgroundImages: backgroundImages
  });
  var hasBottomCorners = props.hasBottomCorners === undefined ? variant !== 'image' : props.hasBottomCorners && variant !== 'image';
  // console.log(hasBackgroundImages, backgroundImages, variant);
  var aspectRatio = customAspectRatio || defaultAspectRatios[variant];
  var hasBannerTitles = showTitles && (!!entity.title || !!entity.name);
  var title = entity.title || entity.name;
  var fontScale = title.length > 50 ? 0.8 : 1;
  var inner = React.createElement(My.Container, {
    colors: {
      border: (_b = entity.color) === null || _b === void 0 ? void 0 : _b.value
    },
    className: cls.name(className)
  }, React.createElement(My.Slice, {
    maxHeight: maxHeight,
    overlayColor: showOverlay && "#00000022",
    aspectRatio: aspectRatio,
    entity: pageSlice,
    boundary: 'none',
    hasChildren: !children,
    hasBackgroundImages: hasBackgroundImages,
    useBackgroundColor: useBackgroundColor,
    hasBottomCorners: hasBottomCorners,
    colors: {
      background: (_c = entity.color) === null || _c === void 0 ? void 0 : _c.value
    },
    slideControls: {
      variant: 'line',
      showNavigationButtons: false
    },
    useLinks: useLinks
  }, React.createElement(My.Layout, {
    useBackgroundColor: useBackgroundColor
  }, hasBannerHeader && React.createElement(React.Fragment, null, React.createElement(My.OutlineEntity, __assign({}, entityValueProps, {
    useBackgroundColor: useBackgroundColor,
    variant: 'bannerLarge',
    entity: entity
  }))), hasBannerTitles && React.createElement(My.Titles, null, !!link && React.createElement(My.TypeHeader, {
    entity: entity
  }), React.createElement(My.Title, {
    fontScale: fontScale
  }, title)), content && React.createElement(My.Content, null, content), children && React.createElement(My.Body, null, children))), hasSubHeader && React.createElement(My.SubHeaderContainer, {
    subHeaderBackgroundColor: subHeaderBackgroundColor
  }, React.createElement(My.OutlineEntity, __assign({}, entityValueProps, {
    useBackgroundColor: useBackgroundColor,
    variant: 'bannerLarge',
    entity: entity
  }))));
  return React.createElement(ThemeModeProvider, {
    value: variant === 'overlay' ? 'dark' : 'light'
  }, React.createElement(React.Fragment, null, isClickable ? React.createElement(Link, {
    href: link,
    style: style
  }, inner) : inner));
};
// EntityBanner.defaultProps = EntityBannerDefaultProps;
EntityBanner.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38;